<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Vendeurs",
          icon: "bi bi-person-badge-fill",
          route: "sellers-index",
        },
        {
          label: "Nouveau vendeur",
          icon: "bi bi-person-plus-fill",
          route: "sellers-create",
        },
      ],
    };
  },
};
</script>
